import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Table } from '../../../common/table'
import { INDUSTRY_TYPE } from '../constant'
import {
  selectCompanyInfoDetail,
  selectICBById,
  selectVSICById,
} from '../store/slice'
import { IndustryName } from './IndustryName'
import classes from './index.module.scss'

export const IndustryTable = ({ type }) => {
  const isVSIC = type === INDUSTRY_TYPE.VSIC

  const rowIds = useSelector(
    selectCompanyInfoDetail((data) => {
      const industryData = isVSIC ? data.vsicIndustries : data.icbIndustries
      if (!industryData) return []
      return industryData.map((item) => (isVSIC ? item.vsicId : item.icbId))
    }),
  )

  return (
    <Element className={classes.industryTable}>
      <Table
        ids={rowIds}
        getDataFromRedux={isVSIC ? selectVSICById : selectICBById}
        schema={[
          {
            colId: isVSIC ? 'vsicCode' : 'icbCode',
            title: 'companyProfile.INDUSTRY_CODE',
            isI18n: true,
            tdStyle: { width: '30%' },
          },
          {
            colId: isVSIC ? 'vsicId' : 'icbId',
            title: isVSIC
              ? 'companyProfile.MAIN_VSIC'
              : 'companyProfile.MAIN_ICB',
            isI18n: true,
            render: (data) => <IndustryName isVSIC={isVSIC} id={data} />,
          },
        ]}
        noDataText="common.NO_DATA"
        autoHeightMax={200}
      />
    </Element>
  )
}
